import { JIRA_LABELS } from 'src/common/consts/jira-labels';
import { ProductType } from 'src/common/interfaces/Tenant';
import { PlatformIssueDetails } from 'src/common/types/IssueDetailsType';
import { Report } from 'src/common/types/ReportModel';

export const getJiraLabelBySource = (source: ProductType): string => {
	switch (source) {
		case ProductType.WEB_FLOW_ANALYZER:
			return JIRA_LABELS.evincedWfaIssue;
		case ProductType.WEB_SDK:
			return JIRA_LABELS.evinceWebSDKIssue;
		case ProductType.MOBILE_FLOW_ANALYZER:
			return JIRA_LABELS.evincedMFAIssue;
		case ProductType.MOBILE_SDK:
			return JIRA_LABELS.evincedmobileSDKIssue;
		default:
			return JIRA_LABELS.evincedWfaIssue;
	}
};

export const mapPlatformIssueDetailsToReport = (
	issue: PlatformIssueDetails,
	isDefaultLabelsEnabled: boolean,
	source: ProductType
): Report => ({
	...issue,
	pageUrl: issue.url,
	signature: '',
	severity: { id: issue.severity, name: issue.severity, newId: issue.severity },
	type: { id: issue.type, name: issue.type, newId: issue.type },
	pageScreenshot: issue.screenshotUrl,
	labels: isDefaultLabelsEnabled ? [getJiraLabelBySource(source)] : []
});
